jQuery(document).ready(function($) {
    var $menuAncora = $('.menu-anchor');

    if(!$menuAncora.length) return

    $menuAncora.on('click', 'a', function(e) {

        e.preventDefault();

        var $this = $(this);
        var link = $this.attr('href');
        var rel = $this.attr('rel');
        var scroll = link.replace("#", "");

        if(menu_anchor_script.front_page == 1 && rel == 'ancora-home') {
            window.location.href = menu_anchor_script.site_url + '?scroll=' + scroll;
        } else {
            $('html, body').animate({
                scrollTop: $(link).offset().top
            }, 700);
        }
    });
});